export default function PHP_log() {
  return (
    <div>
      <h1>PHP_log</h1>
    </div>
  );
}
